import { library, config } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faTimes, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import '@fortawesome/fontawesome-svg-core/styles.css';

// Prevent auto-adding CSS since we import it manually
config.autoAddCss = false;

library.add(faSearch, faTimes, faChevronDown);
